<template>
  <v-container>
    <v-card flat>
      <!-- <v-btn class="ma-6" @click="step === 2 ? (step = 0) : step++"
        >Add Step</v-btn
      > -->
      <v-card-text class="fullHeigth d-flex justify-center align-center">
        <transition name="component-fade" mode="out-in">
          <template v-if="step === 0">
            <PantallaBienvenida @change-step="onChangeStep" />
          </template>
          <template v-if="step === 1">
            <PantallaTest @change-step="onChangeStep" />
          </template>
          <template v-if="step === 2">
            <PantallaFinalizado @change-step="onChangeStep" />
          </template>
        </transition>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  components: {
    PantallaBienvenida: () => import("./Bienvenida"),
    PantallaTest: () => import("./Test"),
    PantallaFinalizado: () => import("./Finalizado")
  },

  data() {
    return {
      step: 0
    };
  },

  methods: {
    onChangeStep(step) {
      this.step = step;
    }
  }
};
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fullHeigth {
  height: calc(100vh - 176px);
}
</style>
